<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $tc('add') }} {{ $tc('sound', 1) }} {{ $tc('format',1)}}</div>
      <router-link
        class="btn-blue"
        to="sound-formats"
      >{{$t('sound')}} {{ $tc('format', 1) }} {{ $tc('list',1) }}</router-link>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="sound_format_name"
                name="sound_format_name"
                v-validate="'required'"
                v-model="sound_format_name"
                placeholder="."
              />
              <label>Sound Format Name</label>
            </div>
            <Tooltip :title="$t('movieselectsound_tooltip')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('sound_format_name')"
            >{{ errors.first('sound_format_name') }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="sound_format_order"
                name="sound_format_order"
                v-validate="'required'"
                v-model="sf_order"
                placeholder="."
              />
              <label>{{$t('order')}}</label>
            </div>
            <Tooltip :title="$t('FormatOrder_tooltip')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('sound_format_order')"
            >{{ errors.first('sound_format_order') }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <label class="ios-switch">
              <input type="checkbox" class="ios-checkbox" v-model="sound_format_is_active" />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button @click.prevent.stop="addFormat()" class="btn-blue">{{ $t('save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      sound_format_name: "",
      sf_order: "",
      sound_format_is_active: true
    };
  },
  methods: {
    addFormat() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // let loader = this.$loading.show();

          // console.log("JSON.stringify :", JSON.stringify(finalObj));
          let payload = {
            sound_format_name: this.sound_format_name,
            sf_order: this.sf_order,
            sound_format_is_active: this.sound_format_is_active
          };
          MasterService.AddSoundFormat(payload)
            .then(response => {
              const { data } = response;
              // loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/master/sound-formats"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>

    



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SoundFormatsComponent/addSoundFormat.vue